import { render, staticRenderFns } from "./DialogProtestBill.vue?vue&type=template&id=4ac1b7d0"
import script from "./DialogProtestBill.vue?vue&type=script&lang=js"
export * from "./DialogProtestBill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports